
export interface TimeSegment {
  id: string;
  openTime: string; // Format: "9:00 AM"
  closeTime: string; // Format: "6:00 PM"
}

export interface BusinessHour {
  day: 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';
  active: boolean;
  startTime: string;
  endTime: string;
  segments?: TimeSegment[];
}

export interface BusinessUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: 'Owner' | 'View Only' | 'Primary Owner';
  avatarUrl: string | null;
}

export interface LeadDeliverySettings {
  phone: string;
  phoneUserId?: string; // ID of the user associated with this phone
  email: string;
  emailUserId?: string; // ID of the user associated with this email
  onlyDuringBusinessHours: boolean;
  businessHours: BusinessHour[];
}

export const defaultBusinessHours: BusinessHour[] = [
  { 
    day: 'Monday', 
    active: true, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '9:00 AM', 
      closeTime: '6:00 PM'
    }] 
  },
  { 
    day: 'Tuesday', 
    active: true, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '9:00 AM', 
      closeTime: '6:00 PM'
    }] 
  },
  { 
    day: 'Wednesday', 
    active: true, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '9:00 AM', 
      closeTime: '6:00 PM'
    }] 
  },
  { 
    day: 'Thursday', 
    active: true, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '9:00 AM', 
      closeTime: '6:00 PM'
    }] 
  },
  { 
    day: 'Friday', 
    active: true, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '9:00 AM', 
      closeTime: '6:00 PM'
    }] 
  },
  { 
    day: 'Saturday', 
    active: false, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '12:00 PM', 
      closeTime: '5:00 PM'
    }] 
  },
  { 
    day: 'Sunday', 
    active: false, 
    startTime: '09:00',
    endTime: '17:00',
    segments: [{ 
      id: crypto.randomUUID(), 
      openTime: '12:00 PM', 
      closeTime: '3:00 PM'
    }] 
  },
];
